import { MeasuredValue } from "../../../../datamodel/measured-value";

/**
 *
 */
export class MeasuredValueV1 {
    public name?: string;
    public value?: string;
    public unit?: string;
    public systemValue?: boolean = false;

    public static fromEntity(value: MeasuredValue): MeasuredValueV1 {
        return {
            name: value.name,
            value: value.value,
            unit: value.unit,
            systemValue: value.systemValue ?? false
        };
    }

    public static toEntity(value: MeasuredValueV1): MeasuredValue {
        return {
            name: value.name,
            value: value.value,
            unit: value.unit,
            systemValue: value.systemValue ?? false
        };
    }
}
